import { render, staticRenderFns } from "./bam-button.vue?vue&type=template&id=ab6f90ae&scoped=true&"
import script from "./bam-button.vue?vue&type=script&lang=js&"
export * from "./bam-button.vue?vue&type=script&lang=js&"
import style0 from "./bam-button.vue?vue&type=style&index=0&id=ab6f90ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6f90ae",
  null
  
)

export default component.exports